import { SideNav, NavBar } from "./components"
import { linksUrl } from "./constants/enum.js"
import {
  ClientMaster,
  AddClientMaster,
  UserMaster,
  AddUserMaster,
  Login,
  EditPasswordClientMaster,
  EditDetailsClientMaster,
  EditUserMaster,
  AdminMaster,
  EditAdminMaster,
  CreateAdminMaster,
  AppMaster,
  CreateAppMaster,
  EditAppMaster,
  AppClientMapping,
  CreateAppClientMapping,
  EditAppClientMapping,
  MenuMaster,
  CreateMenuMaster,
  EditMenuMaster,
  UserMenuMapping, 
  EditUserMenuMapping,
} from "./pages"
import { useSelector } from "react-redux"
import PrivateRoute from "./PrivateRoute" 
import { Routes, Route, useLocation, Navigate } from "react-router-dom"

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth)

  const location = useLocation()

  const shouldShowSidebar = () => {
    const { pathname } = location
    return ![linksUrl.login].includes(pathname)
  }

  return (
    <div className="light">
      {shouldShowSidebar() && (
        <>
          <NavBar />
          <SideNav />
        </>
      )}

      {/* Routes */}
      <Routes>
        <Route
          path={linksUrl.login}
          element={
            !isAuthenticated ? (
              <Login />
            ) : (
              <Navigate to={linksUrl.clientMaster.read} />
            )
          }
        />
        {/* ***private routes */}

        {/* client master */}
        <Route
          path={linksUrl.clientMaster.read}
          element={
            <PrivateRoute>
              <ClientMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.clientMaster.add}
          element={
            <PrivateRoute>
              <AddClientMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.clientMaster.edit.password}
          element={
            <PrivateRoute>
              <EditPasswordClientMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.clientMaster.edit.details}
          element={
            <PrivateRoute>
              <EditDetailsClientMaster />
            </PrivateRoute>
          }
        />

        {/* user master */}
        <Route
          path={linksUrl.userMaster.read}
          element={
            <PrivateRoute>
              <UserMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.userMaster.add}
          element={
            <PrivateRoute>
              <AddUserMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.userMaster.edit}
          element={
            <PrivateRoute>
              <EditUserMaster />
            </PrivateRoute>
          }
        />

        {/* admin master */}
        <Route
          path={linksUrl.adminMaster.read}
          element={
            <PrivateRoute>
              <AdminMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.adminMaster.add}
          element={
            <PrivateRoute>
              <CreateAdminMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.adminMaster.edit}
          element={
            <PrivateRoute>
              <EditAdminMaster />
            </PrivateRoute>
          }
        />

        {/* app master */}
        <Route
          path={linksUrl.appMaster.read}
          element={
            <PrivateRoute>
              <AppMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.appMaster.add}
          element={
            <PrivateRoute>
              <CreateAppMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.appMaster.edit}
          element={
            <PrivateRoute>
              <EditAppMaster />
            </PrivateRoute>
          }
        />

        {/* app client mapping */}
        <Route
          path={linksUrl.appClientMapping.read}
          element={
            <PrivateRoute>
              <AppClientMapping />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.appClientMapping.add}
          element={
            <PrivateRoute>
              <CreateAppClientMapping />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.appClientMapping.edit}
          element={
            <PrivateRoute>
              <EditAppClientMapping />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.menuMaster.read}
          element={
            <PrivateRoute>
              <MenuMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.menuMaster.add}
          element={
            <PrivateRoute>
              <CreateMenuMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.menuMaster.edit}
          element={
            <PrivateRoute>
              <EditMenuMaster />
            </PrivateRoute>
          }
        />

        {/* user menu mapping */}
        <Route
          path={linksUrl.userMenuMapping.read}
          element={
            <PrivateRoute>
              <UserMenuMapping />
            </PrivateRoute>
          }
        />  
        <Route
          path={linksUrl.userMenuMapping.edit}
          element={
            <PrivateRoute>
              <EditUserMenuMapping />
            </PrivateRoute>
          }
        /> 
  
      </Routes>
    </div>
  )
}

export default App
